import { FC, PropsWithChildren } from 'react';

import { Stack, StyleProps } from '@bonusly/design-system';

export const FormSection: FC<PropsWithChildren<StyleProps>> = (props) => {
	return <Stack p={5} bgColor="bg.surface" borderRadius="lg" spacing={4} {...props} />;
};
